import { render, staticRenderFns } from "./TimelineEducate.vue?vue&type=template&id=4604df24&scoped=true&"
import script from "./TimelineEducate.vue?vue&type=script&lang=js&"
export * from "./TimelineEducate.vue?vue&type=script&lang=js&"
import style0 from "./TimelineEducate.vue?vue&type=style&index=0&id=4604df24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4604df24",
  null
  
)

export default component.exports